import { MarkItViewApi } from '../../../../Apis/Apis';
import {
  CommodityManagementSiteAccessModel,
  MarketViewUserModel,
  UserSiteAccessAddModel,
  UserSiteAccessUpdateModel,
} from '../../../../Generated/Mark-It-View-Api';
import { LoadingState } from '../../../../Types';

export interface AddUserRequest {
  marketViewUserGuid?: string;
  firstName: string;
  lastName: string;
  email: string;
  companyGuid?: string;
  commodityManagementUserSiteAccesses?: CommodityManagementSiteAccessModel[];
}

export async function saveMarketViewUser(
  request: AddUserRequest,
  setLoadingState?: (state: LoadingState) => void,
): Promise<{ user: MarketViewUserModel; isNew: boolean }> {
  const validSiteAccesses = (request.commodityManagementUserSiteAccesses ?? []).filter(
    (siteAccess): siteAccess is CommodityManagementSiteAccessModel & { siteGuid: string } =>
      siteAccess.siteGuid != null,
  );

  const addUserSiteAccesses: UserSiteAccessAddModel[] | undefined =
    validSiteAccesses.length > 0
      ? validSiteAccesses.map((siteAccess) => ({
          siteGuid: siteAccess.siteGuid,
          isSiteManager: siteAccess.isSiteManager ?? false,
          permissions: siteAccess.permissions ?? [],
        }))
      : undefined;

  const marketViewUserGuid = request.marketViewUserGuid;
  const updateUserSiteAccesses: UserSiteAccessUpdateModel[] | undefined =
    validSiteAccesses.length > 0 && marketViewUserGuid
      ? validSiteAccesses.map((siteAccess) => ({
          marketViewUserGuid,
          siteGuid: siteAccess.siteGuid,
          isSiteManager: siteAccess.isSiteManager ?? false,
          permissions: siteAccess.permissions ?? [],
        }))
      : undefined;

  if (!request.marketViewUserGuid) {
    const response = await MarkItViewApi.addMarketViewUser(setLoadingState, {
      email: request.email,
      firstName: request.firstName,
      lastName: request.lastName,
      companyGuid: request.companyGuid,
      commodityManagementUserSiteAccesses: addUserSiteAccesses,
    });

    return {
      user: response.data.user as MarketViewUserModel,
      isNew: true,
    };
  }

  const response = await MarkItViewApi.updateMarketViewUser(setLoadingState, request.marketViewUserGuid, {
    marketViewUserGuid: request.marketViewUserGuid,
    email: request.email,
    firstName: request.firstName,
    lastName: request.lastName,
    companyGuid: request.companyGuid,
    commodityManagementUserSiteAccesses: updateUserSiteAccesses,
  });

  return {
    user: response.data.user as MarketViewUserModel,
    isNew: false,
  };
}

export async function updateMarketViewUserEnabled(user: MarketViewUserModel): Promise<void> {
  await MarkItViewApi.updateMarketViewUserEnabled(undefined, user.marketViewUserGuid, user.isDisabled);
}
